module.exports = __webpack_public_path__ + "static/media/icon-paid.ddeafd6e.svg";